import React from 'react';

import { TranslationKeys } from 'app/translations';

import type { EmployeeCalculationsPersonal } from 'app/hooks';
import type { CalculationsCardProps } from '../CalculationsCard';
import { CalculationsCard } from '../CalculationsCard';

type EmployeePensionPersonalDetailsPanelProps = {
  loading?: boolean;
  data: EmployeeCalculationsPersonal | undefined;
  onChangeCalculations?: (field: any) => void;
};

export const EmployeePensionPersonalDetailsPanel = ({
  loading = false,
  data,
  onChangeCalculations,
}: EmployeePensionPersonalDetailsPanelProps) => {
  const cardFields = React.useMemo<CalculationsCardProps['fields']>(() => {
    if (data && 'message' in data) {
      return [];
    }

    const rows: any[] = [
      {
        labelId: 'age',
        formulaId: TranslationKeys.employees_pension_calcFormula_age,
        value: {
          value: data?.age,
          type: 'yearsAndMonths',
        },
      },
      {
        labelId: TranslationKeys.employees_pension_employmentStart,
        formulaId: TranslationKeys.employees_pension_copyFromInfo,
        value: {
          value: data?.employmentStartDate,
          type: 'date',
        },
      },
      {
        labelId: TranslationKeys.employees_pension_employmentYearsFrom,
        formulaId: TranslationKeys.employees_pension_copyFromInfo,
        value: {
          value: data?.employmentYearsFrom,
          type: 'date',
        },
      },
      {
        labelId: TranslationKeys.employees_pension_pensionDate,
        formulaId: TranslationKeys.employees_pension_calcFormula_pensionDate,
        value: {
          value: data?.pensionDate,
          type: 'date',
        },
      },
      {
        labelId: TranslationKeys.employees_pension_totalEmploymentTime,
        formulaId: TranslationKeys.employees_pension_calcFormula_totalEmploymentTime,
        value: {
          value: data?.totalEmploymentTime,
          type: 'yearsAndMonths',
        },
      },
      {
        labelId: TranslationKeys.employees_pension_pastEmploymentTime,
        formulaId: TranslationKeys.employees_pension_calcFormula_pastEmploymentTime,
        value: {
          value: data?.pastEmploymentTime,
          type: 'yearsAndMonths',
        },
      },
      {
        labelId: TranslationKeys.employees_pension_futureEmploymentTime,
        formulaId: TranslationKeys.employees_pension_calcFormula_futureEmploymentTime,
        value: {
          value: data?.futureEmploymentTime,
          type: 'yearsAndMonths',
        },
      },
      {
        labelId: TranslationKeys.employees_pension_calculationStartDate,
        formulaId: TranslationKeys.employees_pension_copyFromInfo,
        value: {
          value: data?.calculationStartDate,
          type: 'date',
        },
      },
    ];

    if (onChangeCalculations) {
      rows.unshift({
        labelId: TranslationKeys.personal_policyNumber,
        formulaId: '',
        type: 'input',
        debounceTime: 1000,
        value: {
          value: data?.policyNumber,
          type: 'identifier',
        },
      });
    }

    return rows;
  }, [data, onChangeCalculations]);

  return (
    <CalculationsCard
      isLoading={loading}
      titleId={TranslationKeys.employees_detail_personal}
      fields={cardFields}
      onChangeCalculations={onChangeCalculations}
      error={data?.message}
    />
  );
};
